import { render, staticRenderFns } from "./AnonymizeDocumentModal.vue?vue&type=template&id=436d0bb8&scoped=true"
import script from "./AnonymizeDocumentModal.vue?vue&type=script&lang=ts"
export * from "./AnonymizeDocumentModal.vue?vue&type=script&lang=ts"
import style0 from "./AnonymizeDocumentModal.vue?vue&type=style&index=0&id=436d0bb8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436d0bb8",
  null
  
)

export default component.exports